import {
  ApplicationRef,
  ComponentFactoryResolver,
  Injectable,
  Injector,
  Renderer2,
  RendererFactory2,
  Type,
} from '@angular/core';
import { TableWidthType } from 'jspdf-autotable';

import { TitleService } from './title.service';

@Injectable({ providedIn: 'root' })
export class TableExportService {
  private renderer: Renderer2;

  constructor(
    private injector: Injector,
    private appRef: ApplicationRef,
    private titleService: TitleService,
    private componentFactoryResolver: ComponentFactoryResolver,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  exportWithRender<T>(
    component: Type<T>,
    data: unknown,
    exportFn: (
      tableNativeElement: string | HTMLTableElement,
      titleService: TitleService,
      pageSize: string,
      tableWidth: TableWidthType
    ) => void,
    pageSize?: string,
    tableWidth?: TableWidthType
  ) {
    // 1. Create component
    const factory = this.componentFactoryResolver.resolveComponentFactory(component);
    const componentRef = factory.create(this.injector);

    // 2. Set inputs
    Object.keys(data).forEach((key) => {
      componentRef.instance[key] = data[key];
    });

    // 3. Attach to app for change detection
    this.appRef.attachView(componentRef.hostView);

    // 4. Create a hidden container
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hostElem = (componentRef.hostView as any).rootNodes[0] as HTMLElement;
    const container = this.renderer.createElement('div');
    this.renderer.setStyle(container, 'visibility', 'hidden');
    this.renderer.setStyle(container, 'position', 'absolute');
    this.renderer.setStyle(container, 'top', '0');
    this.renderer.setStyle(container, 'left', '0');
    this.renderer.appendChild(container, hostElem);
    document.body.appendChild(container);

    setTimeout(() => {
      const tableElement = hostElem.querySelector('table');

      if (tableElement) {
        exportFn(tableElement, this.titleService, pageSize, tableWidth);
      } else {
        console.error('No table found in component');
      }

      // Cleanup
      this.appRef.detachView(componentRef.hostView);
      document.body.removeChild(container);
      componentRef.destroy();
    }, 100); // delay to ensure rendering
  }
}
